import { render, staticRenderFns } from "./CpfTooltip.vue?vue&type=template&id=4da50837&"
import script from "./CpfTooltip.vue?vue&type=script&lang=js&"
export * from "./CpfTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports